// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"bdc68800","350":"99e1547e","360":"5464538a","445":"9d11256a","453":"e67b519e","455":"766972e6","536":"ce281882","827":"cbf165f3","854":"d37442e3","944":"31df91be","977":"2626d0aa","994":"1309fd6f"}[chunkId] + ".chunk.js";
};